import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { Map, MapProps } from "react-leaflet";
import { IMapresource } from "../models/Mapresource";

//@ts-ignore
// L.RasterCoords = require('leaflet-rastercoords');

interface RasterMapProps extends MapProps {
    boundingBox: IMapresource["boundingBox"];
    
};

export const RasterMap: React.FC<RasterMapProps> = ({ children, boundingBox, ...mapProps }) => {

    const mapElement = useRef<Map["leafletElement"]>(null)
    const rc = useRef<Map["leafletElement"]>(null);

    const image = [Math.abs(boundingBox.maxX), Math.abs(boundingBox.minY)]

    useLayoutEffect(() => {
        return () => {
            setTimeout(() => {

                if (mapElement.current) {
                    //   mapElement.current.remove()
                }
            }, 200)
        }
    }, [])




    const _onMapReady = (mapComponent: Map) => {
        if (mapComponent) {
            // @ts-ignore
            mapElement.current = mapComponent.leafletElement
            //@ts-ignore
            //  rc.current = new L.RasterCoords(mapComponent.leafletElement, image);
            // mapElement.current.setView(mapElement.current.getCenter(), mapElement.current.getZoom())

        }
    }

    const _onClick: MapProps["onclick"] = (event) => {
        if (mapProps.onclick) {
            mapProps.onclick(event)
        }
    }

    return (
        <Map
            doubleClickZoom={true}
            ref={_onMapReady}
            onclick={_onClick}
            {...mapProps}

        >
            {children}
        </Map>
    );
};